"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertySummariesById = void 0;
const summaries = (list) => list.reduce((final, summary) => (Object.assign(Object.assign({}, final), { [summary.id]: summary })), {});
exports.propertySummariesById = (state = {}, action = {}) => {
    switch (action.type) {
        case 'PROPERTY_SUMMARY_GET_BY_ID_RECEIVE':
            return Object.assign(Object.assign({}, state), { [action.payload.id]: action.payload.summary });
        case 'PROPERTY_SUMMARY_GET_BY_OWNER_RECEIVE':
            return Object.assign(Object.assign({}, state), summaries(action.payload.summaries));
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map